import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectProposalById } from "../../../../../redux/project/action";
import SignContestContract from "./SignContestContract";
import { formatNumberWithCommas, getDateFormate, getDeadlineDate, getTimeFormat } from "../../../../Common/AllDateTimeReleventFormate";
import RoleLabel from "../../../../Common/RoleLabel";
import ClientUserCommonDetails from "../../../../Common/ClientUserCommonDetails";
import ContractView from "../../../../CustomComponents/ContractView";

export default function ContestContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const { id } = useParams();
  const pbi = useSelector(
    ({ project: { getprojectproposalbyid } }) => getprojectproposalbyid,
  );
  const dispatch = useDispatch();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    dispatch(getProjectProposalById(id));
  }, [id]);

  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return dateObj.toLocaleDateString("en-US", options);
  };


  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        {/* <p className="breadcrumbs">
          <a onClick={() => navigate(`/${lan}/searchall`)}>Home &gt; </a>
          <a onClick={() => navigate(-1)}>WBO details &gt;</a> Send offer
        </p> */}
        <p className="breadcrumbs">
          <a onClick={() => navigate(-2)}>{pbi?.is_mine == 1 ? "Manage Work" : "My Order"} &gt; </a>
          <a onClick={() => navigate(-1)}>{pbi?.is_mine == 1 ? "WBO Details" : "All Proposal"} &gt; </a>
          {pbi?.is_mine == 1 ? "Offer" : "Offer"}
        </p>
        <div className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {formatDateString(pbi?.created_on)}</p>
              <p>ID : {pbi?.agreement_id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'contest_agreement'} />
            </div>

            <div className="project-details">
              <div className="flex-sec">
                <p>Contest Details</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Prize Money</p>
                <p>$ {formatNumberWithCommas(posts?.price)}</p>
              </div>

              <div className="flex-sec flex-sec1">
                <p>Competition Last Date</p>
                <p>{getDateFormate(posts?.last_date)}</p>
              </div>

            </div>

            <ClientUserCommonDetails pbi={pbi} />
            <SignContestContract pbi={pbi} />
          </div>
        </div>
      </div>
    </div>
  );
}
